import { render, staticRenderFns } from "./Uniform.vue?vue&type=template&id=7b130bf6&scoped=true&"
import script from "./Uniform.vue?vue&type=script&lang=js&"
export * from "./Uniform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b130bf6",
  null
  
)

export default component.exports